/* Description: Infocard version desktop 7 Js
   Author: Shakti
   Updated On: 04/12/24
   Created On: 20/11/24
   ========================================================================== */

// for mobile function new
function initializeCardOverlayInteraction() {
  try {
    // Exit if viewport is wider than 960px
    if (!window.matchMedia("(max-width: 960px)").matches) {
      return;
    }
    
    const cards = document.querySelectorAll(
      ".ps-infocard-component-layout-v7 .card-img-wrapper"
    );

    cards.forEach((card) => {
      const overlay = card.querySelector(".overlay");
      const closeIcon = card.querySelector(".close-icon"); // Close icon inside the same container
      const link = card.closest(".card").querySelector(".card-link");

      // Handle card click
      card.addEventListener("click", function (event) {
        // Prevent link navigation on first click
        if (!card.classList.contains("active")) {
          event.preventDefault(); // Stop redirection
          card.classList.add("active"); // Add the active class
          card.setAttribute("aria-haspopup", "true");
          card.setAttribute("aria-expanded", "true");
        }
      });

     

      // Prevent direct clicks on the link from triggering navigation unintentionally
      if (link) {
        link.addEventListener("click", function (event) {
          if (!card.classList.contains("active")) {
            event.preventDefault(); // Block navigation if active class is not added
          }
        });
      }

      //Close the overlay when clicking outside the card
      document.addEventListener("click", function (event) {
        cards.forEach((card) => {
          if (!card.contains(event.target)) {
            card.classList.remove("active"); // Remove active class
            card.setAttribute("aria-expanded", "false");
          }
        });
      });

      // Handle click on the close icon to hide or show the overlay and stop redirection
      if (closeIcon) {
        closeIcon.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent any default behavior like link redirection
          event.stopPropagation(); // Prevent the event from bubbling up to the card click handler

          // Toggle the display of the overlay between none and flex
          if (!card.classList.contains("active")) {
            card.classList.add("active");
          } else {
            card.classList.remove("active");
          }

          // Optionally, remove the active class if you want to hide the overlay
         // card.classList.remove("active"); // Remove the active class to close the overlay
         // card.setAttribute("aria-expanded", "false");
        });
      }

       // Handle overlay click
       overlay.addEventListener("click", function (event) {
        if (card.classList.contains("active")) {
          // Allow navigation on second click if active
          if (link) {
            window.location.href = link.href;
          }
        } else {
          event.preventDefault(); // Prevent navigation if overlay is clicked without the active class
        }
      });

    });
  } catch (error) {
    // No error messages in the console
  }
}



// for desktop function
function handleCardInteractionsabove960() {
  try {
    // Select all card-img-wrapper elements
    const cardWrappers = document.querySelectorAll(
      ".ps-infocard-component-layout-v7 .card-img-wrapper"
    );

    // Check if there are any card wrappers on the page
    if (cardWrappers.length === 0) {
      // console.warn("No card wrappers found on the page.");
      return; // Exit if no card wrappers are found
    }

    // Add event listeners for each card-img-wrapper and its respective close icon
    cardWrappers.forEach(function (cardWrapper) {
      // Click event for the card to add 'active' class and set aria attributes
      function activateCard() {
        cardWrapper.classList.add("active");
        cardWrapper.setAttribute("aria-haspopup", "true");
        cardWrapper.setAttribute("aria-expanded", "true");
      }

      // Function to deactivate the card
      function deactivateCard() {
        cardWrapper.classList.remove("active");
        cardWrapper.setAttribute("aria-expanded", "false");
      }

      // Add focus and blur event listeners for keyboard accessibility
      cardWrapper.addEventListener("focus", activateCard);

      // Deactivate card when it loses focus
      cardWrapper.addEventListener("blur", deactivateCard);

      // Find the close icon within this specific card wrapper
      const closeIcon = cardWrapper.querySelector(".close-icon");

      // Check if the close icon exists before adding event listener
      // if (closeIcon) {
      //     // Keydown event for the close icon (for keyboard accessibility)
      //     closeIcon.addEventListener('keydown', function (event) {
      //         // Check if the pressed key is "Enter" or "Space"
      //         if (event.key === "Enter" || event.key === " ") {
      //             console.log('Enter or Space key pressed on close icon');
      //             event.preventDefault(); // Prevent any default action for these keys
      //             deactivateCard(); // Deactivate the card when key is pressed
      //         }
      //     });
      // } else {
      //     console.warn('Close icon not found for card wrapper:', cardWrapper);
      // }
    });
  } catch (error) {
    console.error(
      "An error occurred while initializing card interactions:",
      error
    );
  }
}

// Initialize card interactions on DOMContentLoaded event
document.addEventListener("DOMContentLoaded", function () {
  // handleCardInteractions();
  handleCardInteractionsabove960();
  initializeCardOverlayInteraction();
});
